import {NgModule} from '@angular/core';
import {GnTreeDirective} from './tree.directive';


@NgModule({
  declarations: [GnTreeDirective],
  exports: [GnTreeDirective],
  imports: [],
  entryComponents: []
})
export class GnTreeModule {
}
